// internal-deps
import { SECURE_CARD_INFO_ACTION } from "@swiggy-private/payment-ui";

// hooks
import useCardEvents from "@payment-client/hooks/UseCardEvents";

// constants
import { SCREEN_NAME } from "@payment-client/analytics/constants";

interface ReturnType {
    //click events
    onSaveCardClick: (value: boolean) => void;
    onSecureCardInfoView: VoidFunction;
    onSecureCardInfoClickAction: (action: SECURE_CARD_INFO_ACTION) => void;
    onKnowMoreTokenizationClickAction?: VoidFunction;
}

export const useCardHandlerPaymentModes = (screenName?: string): ReturnType =>
    useCardEvents(screenName ?? SCREEN_NAME.PAYMENT_MODES);
